<template>
  <div class="FormCheckBoxGroups">

    <template v-if="view === 'vertical'">
      <div v-for="subgroup,indexSG in subGroups" :key="indexSG" class="md-list-item-subgroup" style="border:none">

        <div class="md-list-item-text">
          <div @click="ToggleListGroup(indexSG)" class="btn" :class="(expandgroupList.includes(indexSG)) ? 'hideBorder' : 'title-subgroup'">
            <span style="float:left">{{subgroup['translation']}} <b class="card-count">({{checkCountGroup(subgroup.parametrs)}})</b></span>
            <svg v-if="expandgroupList.includes(indexSG)" style="margin: 0px;  padding: 0px;  position: relative;  right: 20px;  width: 20px;  top: 3px;  color: #797979;"
              xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
              <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
            </svg>
            <svg v-else style="margin: 0px;  padding: 0px;  position: relative;  right: 20px;  width: 20px;  top: 3px;  color: #797979;"
            xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>
          </div>
        </div>

        <div v-if="expandgroupList.includes(indexSG) && subgroup.parametrs" class="md-item-subgroup" :class="(expandgroupList.includes(indexSG)) ? 'border-bottom': ''">
          <div id="cards">
            <!-- <template v-if="Object.keys(params).length>10">
              <div>
                <input v-model="searchInp" @input="searchingInputs" placeholder="szukaj parametru ..." type="text" style="margin: 0px 0px 10px;padding: 4px 12px;  border: 1px solid #3498db;  color: #3498db;  border-radius: 6px;width: 85%;">
              </div>
            </template> -->
            <div :class="(attributes_position && attributes_position == 'vertical' ? 'pos-vertical' : 'pos-horizon')">
              <template v-for="(param, paramIndex) in subgroup.parametrs">
                <div class="card" :key="paramIndex">
                <label for="aaa"></label>
                <input type="checkbox" :name="tabName" v-model="dataInputs" :value="[tabName, param.value]" @change="onChangeCheckBox" :disabled="param.count == 0">
                  <span class="card-value" :class="((param.count == 0) ? 'noactive' : '')">{{(param.translation) ? param.translation : Number(param.value)}} {{(suffix) ? suffix : ''}}</span>
                  <span class="card-count" :class="((param.count == 0) ? 'noactive' : '')">({{param.count}})</span>
                </div>
              </template>
            </div>
          </div>
        </div>

      </div>
    </template>

    <template v-else>
      <div id="cards">
            <template v-if="Object.keys(subGroups).length>10">
            <div>
              <input v-model="searchInp" @input="searchingInputs" :placeholder="$t('szukaj_parametru')" type="text" style="margin: 0px 0px 10px;padding: 4px 12px;  border: 1px solid #3498db;  color: #3498db;  border-radius: 6px;width: 85%;">
            </div>
          </template>
        <div class="pos-horizon">
          <div v-for="subgroup,indexSG in searching" :key="indexSG" class="md-list-item-subgroup" style="border:none">
              <template v-for="(param, paramIndex) in subgroup.parametrs">
                <div class="card" :key="paramIndex">
                  <label for="aaa"></label>
                  <input type="checkbox" :name="tabName" v-model="dataInputs" :value="[tabName, param.value]" @change="onChangeCheckBox" :disabled="param.count == 0">
                    <span class="card-value" :class="((param.count == 0) ? 'noactive' : '')">{{(param.translation) ? param.translation : Number(param.value)}} {{(suffix) ? suffix : ''}}</span>
                    <span class="card-count" :class="((param.count == 0) ? 'noactive' : '')">({{param.count}})</span>
                </div>
              </template>
          </div>
        </div>
      </div>

    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "FormCheckBoxGroups",
  props: ["subGroups", "tabName","suffix","view","toggle"], // ["tabId", "tabName", "param", "count", "quantity", "single"],
  data() {
    return {
      searchInp: '',
      value: [0, 10000],
      value_min: 0,
      value_max: 10000,
      dataInputs: [],
      expand: {},
      expandSingle: false,
      expandList: [],
      expandgroupList: []
    };
  },
  computed: {
    ...mapGetters('products',["dataValue", "attributes_active","attributes_position"]),
    searching () {
      let searchArr = []
      let orders = this.subGroups
      const self = this
      if (orders && this.searchInp != '') {
        Object.keys(orders).forEach(function (key) {
          if ((orders[key].value && orders[key].value.toLowerCase().includes(self.searchInp.toLowerCase())) || (orders[key].translation && orders[key].translation.toLowerCase().includes(self.searchInp.toLowerCase()))) {
            searchArr.push(orders[key])
          }
        })
      } else {
        searchArr = orders
      }
      return searchArr
    }
  },
  watch: {
    attributes_active (newValue) {
      this.changeValuesAxios(newValue)
    }
  },
  methods: {
    ToggleListGroup (item) {
      if (this.expandgroupList.includes(item)) {
        const index = this.expandgroupList.indexOf(item);
        if (index > -1) { // only splice array when item is found
          this.expandgroupList.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        this.expandgroupList.push(item)
      }
    },
    checkCountGroup (item) {
      var suma = 0;
      item.forEach(elem => {
        suma += Number(elem.count)
      })
      return suma
    },
    searchingInputs () {
      // console.log(this.searchInp)
    },
    changeValuesAxios (data) {
      if (data[this.tabName]) {
        this.dataInputs = []
        data[this.tabName]['values'].forEach(element => {
          this.dataInputs.push([this.tabName, element])
        });
      } else {
        this.dataInputs = []
      }
    },
    onChangeCheckBox () {
      this.setDataValue(this.dataInputs)
    },
    setDataValue (item) {
      console.log('parentTranslation: ', this.parentTranslation)
      var output = []
      item.forEach(element => {
        // console.log(element)
        if(output[element[0]] && output[element[0]]['values']) {
          output[element[0]]['values'].push(element[1])
          if (element[2]) {
            output[element[0]]['translation'] = this.parentTranslation
          }
        } else {
          output[element[0]] = []
          output[element[0]]['values'] = []
          output[element[0]]['values'].push(element[1])
          if (element[2]) {
            output[element[0]]['translation'] = this.parentTranslation
          }
        }
      });
      if (item.length == 0) {
        output[this.tabName] = []
      }
      this.$store.dispatch('products/set_data_values', output)
    }
  },
  created() {
    if (this.toggle) {
      this.changeValuesAxios(this.attributes_active)
    }
  }
};
</script>

<style scoped>
.border-bottom {
  border-bottom:1px solid #cacaca
}
.card input {
  width:20px;
}
.card-count {
  font-size: 11px;
  color:#5494ff;
  font-weight: normal;
}
 .noactive {
    color: rgb(214, 214, 214);
  }
  .card-value {
    display: inline;
    white-space: break-spaces;
  }
  .pos-vertical {
    max-height: 300px;  overflow-y: auto;
  }
  .pos-horizon {
    overflow-y: auto;
  }
  /* =============== CHECKBOX ================= */
  #FormCheckbox {
    display: table;
    margin-bottom: 0px;
  }
  ul.TemplateParametrs #FormCheckbox {
    display: table;
    margin-bottom: 5px;
  }
  #FormCheckbox h5 {
    margin-left: 30px !important;
    position: relative;
    white-space: normal;
    float: left;
    top: 2px;
  }
  #FormCheckbox .md-checkbox {
    display: flex !important;
    margin: 5px !important;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 5px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    height: 6px;
    margin-left: 2px;
  }
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 2px #737373 solid;
    border-radius: 2px;
  }
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .container input:checked ~ .checkmark {
    background-color: #448aff;
    border: none;
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .container input:checked ~ .checkmark:after {
    display: block;
  }
  .container .checkmark:after {
    left: 6px;
    top: 2px;
    width: 8px;
    height: 13px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .md-list-item-subgroup {
    padding: 10px 0px 0px;
  }
  .title-subgroup {
    border-bottom: 1px solid rgb(202, 202, 202);
    border-right: 0px solid rgb(202, 202, 202);
  }
  .title-subgroup span {
    margin-left:20px;
    width: 352px;
  }
  .hideBorder span {
    margin-left:20px;
    width: 352px;
  }
</style>




// WEBPACK FOOTER //
// src/components/fields/FormCheckBoxGroups.vue